<script lang="ts" setup>
import { useShortCodesStore } from '../_runtime/stores/shortcodes';
import { ComponentsList } from '../_runtime/enums/shortcodes';
import ShortCodesTypesGrid from './modal/Grid.vue';
import ShortCodesListOfGivenType from './modal/List.vue';
import ShortCodesFormOfGivenType from './modal/Form.vue';

const props = defineProps<{
    editId: string | boolean | undefined;
    formId: string | boolean | undefined;
    typeId: string | boolean | undefined;
    closeConfigurator: boolean;
}>();

const store = useShortCodesStore();
const $attrs = useAttrs();

const idShortCodeType = ref<any>(0);
const idDynamicFormShortCodeType = ref<any>(0);
const editShortCodeId = ref(0);

const emit = defineEmits<{
    (e: 'close', id: number, name: string, formId: number, typeId: number): void;
    (e: 'removeShortCode', id: number): void;
}>();

const editElement = computed(() => props.editId);
const closeConfiguratorModal = computed(() => props.closeConfigurator);

onBeforeMount(() =>
{
    if (closeConfiguratorModal.value)
    {
        store.modalSection = ComponentsList.Grid;
    }

    if (editElement.value)
    {
        idShortCodeType.value = props.typeId;
        idDynamicFormShortCodeType.value = props.formId;
        setEditId(Number(editElement.value));
    }
});

const moduleComponent = computed(() =>
{
    if (store.modalSection == ComponentsList.Grid)
    {
        return ShortCodesTypesGrid;
    }

    if (store.modalSection == ComponentsList.List)
    {
        return ShortCodesListOfGivenType;
    }

    if (store.modalSection == ComponentsList.Form)
    {
        return ShortCodesFormOfGivenType;
    }

    return undefined;
});

const currentProperties = computed(() =>
{
    return {
        id: idShortCodeType.value,
        dynamicForm: idDynamicFormShortCodeType.value,
        editShortCodeId: editShortCodeId.value
    };
});

const setId = (id: number, formOriginId: number): void =>
{
    idShortCodeType.value = id;
    idDynamicFormShortCodeType.value = formOriginId;
    store.modalSection = ComponentsList.List;
};

const setEditId = (id: number): void =>
{
    editShortCodeId.value = id;
    store.modalSection = ComponentsList.Form;
};

function close(id: number, name: string, formId: number, typeId: number)
{
    emit('close', id, name, formId, typeId);
}

function removeShortCode(id: number)
{
    emit('removeShortCode', id);
}
</script>

<template>
    <component
        :is="moduleComponent"
        v-bind="$attrs"
        :properties="currentProperties"
        :dynamic-form="idDynamicFormShortCodeType"
        :edit-short-code-id="editShortCodeId"
        @active="setId"
        @edit="setEditId"
        @close-modal="close"
        @remove-short-code="removeShortCode"
    />
</template>
